import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IFlightSearchRequest, IPassengerBookingRequest, IFinalFlightBookingRequest, IBookingScreenshotRequest, ICardPaymentRequest, ICheckPromoCodeRequest, ICheckUserExistRequest, IEMIOptionListRequest, IGSTRequest, INetBankingRequest, IPayByEMIRequest, IPayByRewardPoints, IPayByUPIRequest, IPaymentConvenceFeeRequest, IPaymentScreenshotRequest, IRemovePromoCodeRequest, ITestPaymentRequest, IWalletPaymentRequest } from '../models/request/IRequest';

@Injectable({
  providedIn: 'root'
})
export class FlightService {

  baseUrlFlight = environment.flightConfig.apiUrl;  // Flight API url

  constructor(private http: HttpClient) { }

  // for one way and return search flight api
  searchFlight(reqBody: IFlightSearchRequest) {
    return this.http.post(`${this.baseUrlFlight}apiV2/flight/search`, reqBody)
  }

  multicityFlightSearch() {

  }

  addPassengerDetail(reqBody: IPassengerBookingRequest) {
    return this.http.post(`${this.baseUrlFlight}apiV2/flight/booking`, reqBody)
  }

  bookFlight(bookingId: number) {
    return this.http.post(`${this.baseUrlFlight}apiV2/flight/pnrBooking`, { booking_id: bookingId })
  }

  finalBooking(bookingId: number, req: IFinalFlightBookingRequest) {
    return this.http.post(`${this.baseUrlFlight}apiV2/bookingClass/final-booking/${bookingId}`, req);
  }

  getCarrier() {
    return this.http.get(`${this.baseUrlFlight}apiV2/carrier`)
  }

  getTravelBookingClass() {
    return this.http.get(`${this.baseUrlFlight}apiV2/bookingClass`)
  }

  getAirports() {
    return this.http.get(`${this.baseUrlFlight}apiV2/airport`)
  }

  getBookingIdFromDeepLink(link: string) {
    return this.http.get(link);
  }

  sendBookingScreenshot(req: IBookingScreenshotRequest) {
    return this.http.post(`${this.baseUrlFlight}b2c2/booking/ScreenShot`, req);
  }

  // <<<<<<<<<<<<<<<<------------------ Country HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>
  getCountryList() {
    return this.http.get(`${this.baseUrlFlight}apiV2/country/index`)
  }

  getCountryStates(countryId: string) {
    return this.http.post(`${this.baseUrlFlight}apiV2/country/state`, { country_id: countryId })
  }

  getCountryCity(stateId: string) {
    return this.http.post(`${this.baseUrlFlight}apiV2/country/city`, { state_id: stateId })
  }

  // <<<<<<<<<<<<<<<<------------------ Promo HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>

  getPromoList() {
    return this.http.get(`${this.baseUrlFlight}apiV2/bookingClass/promo-list`)
  }

  checkPromoCode(reqBody: ICheckPromoCodeRequest) {
    return this.http.post(`${this.baseUrlFlight}apiV2/bookingClass/check-promo-code`, reqBody)
  }

  getActiveInsuranceList(bookingId: string) {
    return this.http.post(`${this.baseUrlFlight}apiV2/insurance/active-insurance-list/${bookingId}`, {});
  }

  getInsuranceList(reqBody: any) {
    return this.http.post(`${this.baseUrlFlight}pg/paymentApi/getInsurance`, reqBody);
  }

  removePromoCode(reqBody: IRemovePromoCodeRequest) {
    return this.http.post(`${this.baseUrlFlight}apiV2/bookingClass/remove-promo-code`, reqBody)
  }

  // <<<<<<<<<<<<<<<<------------------ Payment HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>

  getPaymentOptions(bookingId: string) {
    return this.http.post(`${this.baseUrlFlight}pg/paymentApi/GetPayOptions/${bookingId}`, {});
  }

  getPaymentConvenceFee(req: IPaymentConvenceFeeRequest) {
    return this.http.post(`${this.baseUrlFlight}pg/paymentApi/PymtConvFee`, req);
  }

  // for debit and credit card payment
  cardPayment(bookingId: number, paymentRequest: ICardPaymentRequest) {
    const body = new URLSearchParams();
    body.set("cc", paymentRequest.card_type),
    body.set("payment[payment_type]", paymentRequest.paymentType);
    body.set("payment[value][type]", paymentRequest.type);
    body.set("payment[value][number]", paymentRequest.cardNumber.toString());
    body.set("payment[value][exp_month]", paymentRequest.expMonth.toString());
    body.set("payment[value][exp_year]", paymentRequest.expYear.toString());
    body.set("payment[value][cvv]", paymentRequest.cvv.toString());
    body.set("payment[value][name]", paymentRequest.name);
    body.set("payment[value][store]", paymentRequest.store.toString());
    body.set("payment[value][currency]", paymentRequest.currency);
    body.set("payment[value][card]", paymentRequest.card.toString());
    body.set("payment[value][payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][gst][gst_in]", paymentRequest.gstIn);
    body.set("payment[value][gst][company_name]", paymentRequest.companyName);
    body.set("payment[value][gst][email]", paymentRequest.email);

    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/apipayment/${bookingId}`, body);
  }

  payByNetBanking(bookingId: number, paymentRequest: INetBankingRequest) {
    let body = new URLSearchParams();
    body.set("payment[payment_type]", paymentRequest.paymentType);
    body.set("payment[value][net_banking]", paymentRequest.netBanking);
    body.set("payment[value][category]", paymentRequest.category);
    body.set("payment[value][currency]", paymentRequest.currency);
    body.set("payment[value][payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][gst][gst_in]", paymentRequest.gstIn);
    body.set("payment[value][gst][company_name]", paymentRequest.companyName);
    body.set("payment[value][gst][email]", paymentRequest.email);

    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/apipayment/${bookingId}`, body);
  }

  payByWallet(bookingId: number, paymentRequest: IWalletPaymentRequest) {
    let body = new URLSearchParams();
    body.set("payment[payment_type]", paymentRequest.paymentType);
    body.set("payment[value][wallet_type]", paymentRequest.walletType);
    body.set("payment[value][currency]", paymentRequest.currency);
    body.set("payment[value][payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][gst][gst_in]", paymentRequest.gstIn);
    body.set("payment[value][gst][company_name]", paymentRequest.companyName);
    body.set("payment[value][gst][email]", paymentRequest.email);

    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/apipayment/${bookingId}`, body);
  }

  payByTestPaymentMethod(bookingId: number, paymentRequest: ITestPaymentRequest) {
    let body = new URLSearchParams();
    body.set("payment[payment_type]", paymentRequest.paymentType);
    body.set("payment[value][currency]", paymentRequest.currency);
    body.set("payment[value][payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][gst][gst_in]", paymentRequest.gstIn);
    body.set("payment[value][gst][company_name]", paymentRequest.companyName);
    body.set("payment[value][gst][email]", paymentRequest.email);

    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/apipayment/${bookingId}`, body);
  }

  payByEMI(bookingId: number, paymentRequest: IPayByEMIRequest) {
    let body = new URLSearchParams();
    body.set("payment[payment_type]", paymentRequest.paymentType);
    body.set("payment[value][payment_option]", paymentRequest.paymentOption);
    body.set("payment[value][planId]", paymentRequest.planId.toString());
    body.set("payment[value][emi_tenure_id]", paymentRequest.emiTenureId.toString());
    body.set("payment[value][currency]", paymentRequest.currency);
    body.set("payment[value][card_number]", paymentRequest.cardNumber.toString());
    body.set("payment[value][exp_month]", paymentRequest.expMonth.toString());
    body.set("payment[value][exp_year]", paymentRequest.expYear.toString());
    body.set("payment[value][cvv]", paymentRequest.cvv.toString());
    body.set("payment[value][name]", paymentRequest.name);
    body.set("payment[value][issuing_bank]", paymentRequest.issuingBank);
    body.set("payment[value][type]", paymentRequest.type);
    body.set("payment[value][category]", paymentRequest.category)
    body.set("payment[value][payOption]", paymentRequest.payOption.toString());
    body.set("CCAvenueEmi[payment_option]", paymentRequest.paymentOption);
    body.set("CCAvenueEmi[planId]", paymentRequest.planId.toString());
    body.set("CCAvenueEmi[emi_tenure_id]", paymentRequest.emiTenureId.toString());
    body.set("CCAvenueEmi[currency]", paymentRequest.currency);
    body.set("CCAvenueEmi[card_number]", paymentRequest.cardNumber.toString());
    body.set("CCAvenueEmi[exp_month]", paymentRequest.expMonth.toString());
    body.set("CCAvenueEmi[exp_year]", paymentRequest.expYear.toString());
    body.set("CCAvenueEmi[cvv]", paymentRequest.cvv.toString());
    body.set("CCAvenueEmi[name]", paymentRequest.name);
    body.set("CCAvenueEmi[issuing_bank]", paymentRequest.issuingBank);
    body.set("CCAvenueEmi[type]", paymentRequest.type);
    body.set("CCAvenueEmi[category]", paymentRequest.category)
    body.set("CCAvenueEmi[payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][gst][gst_in]", paymentRequest.gstIn);
    body.set("payment[value][gst][company_name]", paymentRequest.companyName);
    body.set("payment[value][gst][email]", paymentRequest.email);

    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/apipayment/${bookingId}`, body);
  }

  payByUPI(bookingId: number, paymentRequest: IPayByUPIRequest) {
    let body = new URLSearchParams();
    body.set("payment[payment_type]", paymentRequest.paymentType);
    body.set("payment[value][currency]", paymentRequest.currency);
    body.set("payment[value][virtual_address]", paymentRequest.virtualAddress);
    body.set("payment[value][payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][category]", paymentRequest.category)
    body.set("UPI[currency]", paymentRequest.currency);
    body.set("UPI[virtual_address]", paymentRequest.virtualAddress);
    body.set("UPI[payOption]", paymentRequest.payOption.toString());
    body.set("payment[value][gst][gst_in]", paymentRequest.gstIn);
    body.set("payment[value][gst][company_name]", paymentRequest.companyName);
    body.set("payment[value][gst][email]", paymentRequest.email);

    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/apipayment/${bookingId}`, body);
  }

  payByRewardPoint(paymentRequest: IPayByRewardPoints) {
    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/RewardzBalance`, paymentRequest);
  }

  getEMIOptionList(emiListRequest: IEMIOptionListRequest) {
    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/CCAvenueEMI`, emiListRequest);
  }

  getUPIOptionList(orderId: number) {
    return this.http.post(`${this.baseUrlFlight}pg/bookingApi/HdfcUPI`, { orderId });
  }

  getWalletTransactionList() {

  }

  getReferralsList() {

  }

  getWalletBalance(userId: string) {

  }

  addNewReferral() {

  }

  getInsurance() {

  }

  getGSTInfo(req: IGSTRequest) {
    return this.http.post(`${this.baseUrlFlight}/pg/paymentApi/CheckGstInformation`, req);
  }

  sendPaymentScreenshot(req: IPaymentScreenshotRequest) {
    return this.http.post(`${this.baseUrlFlight}pg/paymentApi/ScreenShot`, req);
  }

  // <<<<<<<<<<<<<<<<------------------ Auth HTTP REQUESTS------------------------>>>>>>>>>>>>>>>>>
  checkUser(req: ICheckUserExistRequest) {
    return this.http.post(`${this.baseUrlFlight}apiV2/auth/check-user`, req);
  }

  generateRefreshToken() {
    return this.http.post(`${this.baseUrlFlight}apiV2/auth/refresh-token`, {});
  }

}
